import React from "react";
import { Link } from "react-router-dom";

const FlexContainer = {
  display: "flex",
  justifyContent: "center"
};

const FooterStyle = {
  marginTop: "-60px",
  marginLeft: "5px",
  marginRight: "5px",
  color: "black"
};

const Trademark = {
  display: "flex",
  justifyContent: "center",
  marginTop: "-20px",
  fontFamily: "Comfortaa",
  fontSize: "1em"
};

const Footer = () => (
  <footer className="footer">
    <div style={FlexContainer}>
      <div>
        <Link to="/team">
          <h5 style={FooterStyle}>Our Team</h5>
        </Link>
      </div>
      <div>
        <Link to="/tech">
          <h5 style={FooterStyle}>Tech Stack</h5>
        </Link>
      </div>
    </div>

    <span>
      <p style={Trademark}>2018 &copy; Foodbook</p>
    </span>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/small/Footer.jsx